var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { useQuery } from "@apollo/client";
import ShareSvg from "assets/svg/share.svg";
import { groupBy } from "lodash";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Flex, Text } from "rebass";
import Title from "src/components/typography/Title";
import { Content } from "src/components/utilities/Containers";
import { LoadingContext } from "src/context";
import { GET_COLLECTIONS } from "src/queries/collections";
import { svgStyle } from "src/styles/helpers";
import { breakpoints, theme } from "src/styles/theme";
import styled from "styled-components";
import CollectionList from "../CollectionList";
var ShareIcon = styled(ShareSvg)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  height: 2rem;\n\n  @media (min-width: ", ") {\n    min-height: 2.6rem;\n  }\n"], ["\n  ", ";\n  height: 2rem;\n\n  @media (min-width: ", ") {\n    min-height: 2.6rem;\n  }\n"])), svgStyle, breakpoints.md);
var ProposedCollections = function (_a) {
    var proposalCollections = _a.proposalCollections;
    var loadingContext = React.useContext(LoadingContext);
    var t = useTranslation().t;
    var _b = useQuery(GET_COLLECTIONS, {
        variables: {
            withCards: true,
            filterBy: [
                {
                    property: "id",
                    in: proposalCollections.map(function (proposalCollection) {
                        return proposalCollection.collection.id;
                    }),
                },
            ],
        },
    }), data = _b.data, loading = _b.loading;
    var proposalByTeacher = groupBy(proposalCollections, function (proposalCollection) { return proposalCollection.teacher.id; });
    var proposalTuple = React.useMemo(function () {
        if (!(data === null || data === void 0 ? void 0 : data.collections))
            return null;
        return Object.values(proposalByTeacher).map(function (proposalCollections) {
            return [
                proposalCollections[0].teacher,
                proposalCollections.map(function (proposalCollection) {
                    return data.collections.results.find(function (collection) {
                        return collection.id === proposalCollection.collection.id;
                    });
                }),
            ];
        });
    }, [data === null || data === void 0 ? void 0 : data.collections]);
    React.useEffect(function () {
        if (loading) {
            loadingContext.addLoading();
        }
        else {
            loadingContext.removeLoading();
        }
    }, [loading]);
    return (React.createElement(Content, { mt: 3 },
        React.createElement(Flex, { flexDirection: "column", css: "\n          gap: 3rem;\n        " },
            React.createElement(Title, { sm: true, icon: React.createElement(ShareIcon, null) }, t("proposedSeries")), proposalTuple === null || proposalTuple === void 0 ? void 0 :
            proposalTuple.map(function (_a) {
                var teacher = _a[0], collections = _a[1];
                return (React.createElement(Flex, { key: teacher.id, flexDirection: "column", css: "\n              gap: 1rem;\n            " },
                    React.createElement(Text, { color: theme.colors.selectLabel, fontSize: ["1rem", "1rem", "1.5rem"], fontWeight: "semibold" }, t("proposedSeriesBy", {
                        teacher: "".concat(teacher.firstname, " ").concat(teacher.lastname),
                    })),
                    collections && (React.createElement(CollectionList, { stateRedirect: { teacher: teacher.id }, data: collections }))));
            }))));
};
export default ProposedCollections;
var templateObject_1;
